<template>

    <Head>
        <title>Desarrollo integral de la familia</title>
    </Head>
    <div class="hero-img-overlay hero-lila" style="background-image: url('/img/hero-dif.png');">
        <div class="container">
            <div class="row">
                <div class="col-md-6 col-lg-7">
                    <h1 class="hero-encabezado">Programas DIF</h1>
                </div>
            </div>
        </div>
    </div>
    <div class="contenido-wrapper">
        <div class="bloque-general bloque-info-img">
            <div class="container">
                <div class="row flex-md-row-reverse">
                    <div class="col-md-7">
                        <h2 class="bloque-subencabezado">Programas DIF Santiago</h2>
                        <div class="bloque-descripcion">
                            <p>Poniendo a los ciudadanos como el eje de nuestras acciones, acercamos a las personas en condiciones de vulnerabilidad o discapacidad programas enfocados a atender sus necesidades económicas, nutricionales y de salud.</p>
                        </div>
                    </div>
                    <div class="col-md-5">
                        <div class="bloque-info-img__img">
                            <img loading="lazy" width="278" height="245" src="/img/hexa-dif-programas.jpg" alt="DIF">
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="bloque-general bloque-slider-servicios">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <div class="slider-tramites-servicios__encabezado">Conoce los programas federales, estatales y municipales que el DIF Santiago tiene para ti</div>
                        <div class="slider-tramites-servicios row">

                            <div v-for="(item, i) in programas" :key="i"
                                class="tramite-servicio-item col-lg-3 col-md-4 col-sm-12">
                                <img loading="lazy" width="63" height="55" class="tramite-servicio-item__icono"
                                    src="/img/icono-hexagono-lila.svg" alt="" />
                                <Link :href="`/programa/`+item.slug" class="tramite-servicio-item__nombre">{{ item.nombre }}</Link>
                                <div class="tramite-servicio-item__info_corta">{{ item.informacion_corta }}</div>
                                <Link :href="`/programa/`+item.slug" class="boton-terciario boton-flecha">Ver más</Link>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import NoResults from "../../Shared/Utils/NoResults.vue";
import { Link } from '@inertiajs/inertia-vue3'

export default {
    components: {
        NoResults, Link
    },
    props: {
        programas: Object,
    },
}
</script>
<style scoped>
.tramite-servicio-item {
    margin-right: 0 !important;
    margin-bottom: 30px;
}

.fi {
    margin-right: 5px;
    color: #b1b3db;
}
</style>
